module.exports = __webpack_public_path__ + "static/Hospital-8c6cd3d0a03407fcb629f7f014f7bac1.jpg";